import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {Routenames} from './routenames';
import {LocalStorage} from './utils/storage';
import {RouteParamnames} from './route-param-names.enum';

@Injectable()
export class IsNotAuthenticated {
    constructor(private router: Router) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const via = route.queryParams[RouteParamnames.via];
        let tree: UrlTree;
        if (!!via) {
            tree = this.router.createUrlTree(Array.isArray(via) ? via : [via], {queryParams: route.queryParams});
        } else {
            tree = this.router.createUrlTree([Routenames.Home], {queryParams: route.queryParams});
        }

        return LocalStorage.user ? tree : true;
    }
}
